export const CAPTCHA_SITE_KEY: string = '6LcbWKwqAAAAACRthxcpXpOwFrrOC39o_WbxuP9w';
export const PRIVACY_POLICY_URL = 'https://prismforce.com/legal/privacy';
export const TERMS_OF_USE_URL = 'https://prismforce.com/legal/terms-of-use';

export enum LoginState {
    LOGIN = 'login',
    FORGOT_PASSWORD = 'forgotPassword',
    RESET_PASSWORD = 'resetPassword'
}

export enum ResetMode {
    OTP = 'otp',
    DEFAULT_PASSWORD = 'defaultPassword'
}